import { render, staticRenderFns } from "./checkAssetRecord.vue?vue&type=template&id=671a9614&scoped=true&"
import script from "./checkAssetRecord.vue?vue&type=script&lang=js&"
export * from "./checkAssetRecord.vue?vue&type=script&lang=js&"
import style0 from "./checkAssetRecord.vue?vue&type=style&index=0&id=671a9614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a9614",
  null
  
)

export default component.exports